export default "__VITE_ASSET__cdfb8939__"